import React from "react";
import ShowMeasurements from "./show-measurements";

export default function AthleteMeasurementsListAthletic({ result }) {
  const getVideosForMeasurement = (measurementType) => {
    return Object.values(result.measurementVideosByType || {})
      .flat()
      .filter((video) => video.measurementType === measurementType)
      .map((video) => video.filePath);
  };

  return (
    <>
      {[
        { title: "Weight", value: `${result.weight} lbs`, key: "Weight" },
        {
          title: "Height",
          value: `${result.heightFt ?? 0}' ${result.heightIn ?? 0}''`,
          key: "Height",
          deduction: result.heightScratchDeduction,
        },
        {
          title: "Wingspan",
          value: `${result.wingSpanFt ?? 0}' ${result.wingSpanIn ?? 0}''`,
          key: "Wingspan",
          deduction: result.wingSpanScratchDeduction,
        },
        {
          title: "Hand",
          value: `${result.hand ?? 0}''`,
          key: "Hand",
          deduction: result.handScratchDeduction,
        },
        { title: "Foot", value: `${result.foot ?? 0}`, key: "Foot" },
      ].map((measurement) => (
        <React.Fragment key={measurement.key}>
          <ShowMeasurements
            userId={result.userId}
            title={measurement.title}
            value={measurement.value}
            isWeightMeasurement={measurement.key === "Weight"}
            score={
              result.measurementScores?.[
                `${measurement.key.toLowerCase()}Score`
              ] ?? 0
            }
            videoUrls={getVideosForMeasurement(measurement.key)}
            heightComment={result.heightComment}
            deduction={measurement.deduction}
          />
        </React.Fragment>
      ))}
    </>
  );
}
